export function shouldHideRadio(pathname: string) {
  return (
    pathname.startsWith("/admin/") ||
    pathname.startsWith("/les/[lesson]/[head]") ||
    /^\/les\/[^/]+\/[^/]+/.test(pathname)
  )
}
